<script lang="ts">
  import { List, Title } from '$shared/components';
  interface Props {
    value: any;
  }

  let { value }: Props = $props();
</script>

<div class="dea-x-result">
  <div class="dea-x-container">
    <div data-cy="DEA-X-header" class="title">
      <Title type="h3">DEA-X</Title>
    </div>
    <List list={value} />
  </div>
</div>

<style>
  .dea-x-result {
    width: 100%;
    background-color: #fff;
  }
  .dea-x-container {
    margin-top: 20px;
  }
  .title {
    margin-bottom: 20px;
  }
</style>
